import { useCallback, useEffect, useState } from 'react';

export const useTabsState = (currentValue, tabs = []) => {
  const getIndexFromValue = useCallback(
    (value) =>
      tabs.findIndex((item) => {
        return item.key === value;
      }),
    [tabs]
  );

  const [selectedTabIndex, setSelectedTabIndex] = useState(() =>
    getIndexFromValue(currentValue)
  );

  useEffect(() => {
    const index = getIndexFromValue(currentValue);
    if (index !== -1) {
      setSelectedTabIndex(index);
    }
  }, [currentValue, getIndexFromValue]);

  const handleChangeTab = useCallback((_, newIndex) => {
    setSelectedTabIndex(newIndex);
  }, []);

  return {
    selectedTabIndex,
    handleChangeTab,
  };
};
